// extracted by mini-css-extract-plugin
module.exports = {"animatedLink":"styles_animatedLink__6KbXe","line":"styles_line__16zpr"};